<div class="content">
    <div #div1 class="div" [@slideInOut]="{value: animationState, params:{inWidth: fieldWidth}}" *ngIf="!isSingleTypeSequenceViewActive && !isCustomSequenceViewActive && !isChemCompareViewActive">
        <div *ngIf="showField" class="scrollable">
            <form style="display: flex;flex-direction: column">
                <label class="farmHeading-field">{{ farmName }}</label>
                <div class="field-info">

                    <div style="display: flex; flex-direction: row; justify-content: space-evenly; align-items: center;margin: 20px 0">
                        <div style="color: black;display: flex; flex-direction: row; justify-content: center; align-items: center">
                            <span class="field-detail-title">Field Name: </span>
                            <span>{{seasonFormData?.field?.name ?? '-'}}</span>
                        </div>

                        <div style="color: black;display: flex; flex-direction: row; justify-content: center; align-items: center">
                            <span class="field-detail-title">Field Size:</span>
                            <span>{{seasonFormData?.field?.fieldSize ? (seasonFormData.field.fieldSize | truncDecimals:2) : '-'}} HA</span>
                        </div>
                    </div>

<!--                    <app-season-field-input *ngIf="isCallDone && seasonFormData" [inputData]="seasonFormData.detail"  [isInAnotherActiveSeason]="seasonFormData.field.isInAnotherActiveSeason" (formDataChange)="onFormDataChange($event)"></app-season-field-input>-->

                    <div class="flex-row end" style="align-items: center; gap: 8px; margin-top: 15px; margin-bottom: 5px;">
                        <button class="view-details-button" mat-flat-button type="button" (click)="viewFieldDetails()">{{
                            'FIELD.VIEW-DETAILS' |
                            translate }}</button>
                        <button mat-stroked-button type="button" (click)="openFieldInspections()" class="inspections-btn">
                            <mat-icon style="font-size: 16px; height: 16px; width: 16px; line-height: 16px; margin-right: 4px; vertical-align: middle;">assignment</mat-icon>
                            Inspections
                        </button>
                    </div>

                </div>

                <div class="ndvi-heading"  >
                   <div  class="head-btn-container">

                            <div>
                                <p class="ndvi-title-text">{{ 'FIELD.NDVI-INDEX' | translate }} - {{formattedFrom}}
                                    {{ 'FIELD.TO' | translate }} {{formattedTo}}</p>
                            </div>

                       <div>
                           <button class="FilterDates" mat-button type="button" (click)="openDateRange()">
                               <mat-icon class="material-icons">filter_list</mat-icon>
                           </button>
                       </div>

                       <div class="spacer"></div>
                   </div>
                </div>

                <div class="graphs-info">
                    <div class="div4">
                        <div class="graph" id="chart">
                            <div echarts [options]="chartOptions" class="ndvi-chart"
                                 [style.height.px]="350">

                            </div>
                        </div>
                        <!-- <ngx-charts-line-chart [scheme]="colorScheme" [legend]="lineLegend"
                        [showXAxisLabel]="lineShowXAxisLabel" [showYAxisLabel]="lineShowYAxisLabel" [xAxis]="lineXAxis"
                        [yAxis]="lineYAxis" [xAxisLabel]="lineXAxisLabel" [yAxisLabel]="lineYAxisLabel"
                        [results]="ndviChartData" [legendPosition]="lineLegendPosition"
                        [rotateXAxisTicks]="lineRotateXAxisTicks" maxXAxisTickLength="8" trimXAxisTicks="true">
                    </ngx-charts-line-chart> -->
                    </div>
                </div>

                <!-- <button mat-button type="button" (click)="initDrawingManager(map)">
                    <mat-icon class="material-icons">filter_list</mat-icon>
                </button> -->
                <div class="pin-heading">
                    <label>{{ 'FIELD.PIN-SETTINGS' | translate }}</label>
                </div>
                <div class="graphs-info">
                    <div class="div4">
                        <div class="pin-settings">
                            <div class="flex-row">
                                <label class="pin-toggle">{{ 'FIELD.AUTO-UPDATE' | translate }}</label>
                                <mat-slide-toggle [checked]="autoChartsCheck"
                                    (change)="autoChartsChanged($event)"></mat-slide-toggle>
                            </div>
                            <button [disabled]="autoChartsCheck" mat-flat-button class="update-chart-btn"
                                type="button" (click)="updateCharts()">{{'FIELD.UPDATE-CHART' |
                                translate }}</button>
                        </div>
                        <label class="update-discription">{{'FIELD.CHARTS-SETTINGS' | translate }}</label>
                    </div>
                </div>

                <div id="target">
                    <div *ngIf="showGraphs" class="pin-heading">
                        <label>{{ 'FIELD.PIN-ANALYSIS' | translate }}</label>
                    </div>
                    <div *ngIf="showGraphs" class="graphs-info">
                        <div class="div4">
                            <div *ngFor="let data of chartData; i as index" class="pinItem">
                                <mat-card style="box-shadow: 0 2px 6px rgba(153, 153, 153, 0.3);">
                                    <mat-card-content>
                                        <div style="display: flex;flex-direction: column;align-items: center;gap: 20px">
                                            <label class="pinHeading">{{ data[0].chartName.split(' - ')[1] || data[0].chartName }}</label>

                                            <div *ngIf="data[0].isNumericalProperty">
<!--                                                <mat-icon class="material-icons" style="color:#1D73A6">stop</mat-icon>-->
                                                <span class="pinLegend">{{ data[0].legendTitle }}</span>
                                            </div>
                                        </div>

                                        <div id="pinChart" *ngIf="data[0].isNumericalProperty" style="overflow-x: auto;">
                                            <div echarts
                                                 [options]="data[0].option"
                                                 [style.height.px]="350"
                                                 [style.min-width.px]="data[0].option?.xAxis?.data?.length > 5 ? data[0].option.xAxis.data.length * 60 : 300">
                                            </div>
                                        </div>
                                        <div *ngIf="!data[0].isNumericalProperty">
                                            <div class="table pin-container">
                                                <table *ngFor="let data1 of data">
                                                    <caption></caption>
                                                    <tr>
                                                        <th></th>
                                                    </tr>
                                                    <tr>
                                                        <td class=" table-header"> {{ data1?.name }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="table-contents"> {{ data1?.value }} </td>
                                                    </tr>
                                                    <td class="table-contents-bottom">{{ data1?.legendTitle}}</td>
                                                </table>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div *ngIf="showField" class="expand-toggle-button-open" (click)="toggleOverview(div1.offsetWidth)">
            <button mat-icon-button class="expand-icon">
                <mat-icon style="color: white;" [@rotate]="animationState">keyboard_arrow_right</mat-icon>
            </button>
        </div>
        <div *ngIf="!showField && !isSingleTypeSequenceViewActive && !isCustomSequenceViewActive && !isChemCompareViewActive" class="expand-toggle-big-button" (click)="toggleOverview(div1.offsetWidth)">
            <button mat-icon-button class="expand-icon">
                <mat-icon style="color: white;" [@rotate]="animationState">keyboard_arrow_right</mat-icon>
            </button>
        </div>
    </div>


    <div class="responsive-flex" style="display: flex;" [style.flex-direction]="mapTwoIsOpen ? 'row' : 'column'">
        <div #div5 [style.flex]="flex4" class="div5">
            <div class="container">
                <google-map  id="map" #map1 (mapDblclick)="placeMarker($event)" [zoom]="zoom" [options]="options" width="100%"
                    height="100%">
                    <map-ground-overlay *ngFor="let object of fieldImagesMapTwo" [url]="object.image" [bounds]="object.bounds"
                        [opacity]="opacity">
                    </map-ground-overlay>
                    <map-polygon *ngFor="let object of polygon" [paths]="object" [options]="polygonOptions"
                        (polygonDblclick)="placeMarker($event)"></map-polygon>

                    @for (marker of markers; track $index) {
                        <map-advanced-marker class="marker"
                            [position]="marker.position" [content]="marker?.content | cloneNode" [title]="marker.title" (mapDragend)="onMarkerDragEnd(marker, $event)" [gmpDraggable]="marker?.gmpDraggable" (mapClick)="openInfo(marker)">
                        </map-advanced-marker>
                    }
                    

                    <!-- <map-marker #markerId="mapMarker" *ngFor="let marker of markers" [position]="marker.position"
                        [label]="marker.label" [title]="marker.title" (mapClick)="openInfo(marker)"
                        (mapDragend)="onMarkerDragEnd(marker, $event)"
                        [options]="marker.options">
                    </map-marker> -->
                </google-map>


                <div *ngIf="mapsClose && fieldLegendsMapTwo.length != 0" class="scrollableLegend-container legend-container" style="display: flex; flex-direction: column; align-items: end">
                    <div *ngIf="!toggleLegendTwo">
                        <div style="padding: 10px 0" class="scrollableLegend  glassMorphism-effect">
                            <div class="inner-legend-container" *ngFor="let fieldLegend of fieldLegendsMapTwo">
                                <div class="legend-color" [style.background-color]="fieldLegend.color"></div>
                                <label class="legend-value">{{ fieldLegend.value }} ({{ fieldLegend.area }} HA)</label>
                            </div>
                        </div>

                        <div class=" glassMorphism-effect stats-container" *ngIf="isMapTypeSoilMapTwo && historyTitleMapTwo !== 'PROFITABILITY'">
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-min-container">Min:</span> {{ legendStatsMapTwo.min ? legendStatsMapTwo.min : placeholder}} </p>
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-max-container">Max:</span> {{ legendStatsMapTwo.max ? legendStatsMapTwo.max : placeholder}}</p>
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-avg-container">Avg:</span> {{ legendStatsMapTwo.avg ? legendStatsMapTwo.avg : placeholder }}</p>
                        </div>

                        <div class="glassMorphism-effect profitability-stats-container" *ngIf="historyTitleMapTwo === 'PROFITABILITY' && profitabilitySummary">
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Total Profit:</span> R{{ profitabilitySummary.totalProfitability?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Avg Profit/ha:</span> R{{ profitabilitySummary.avgProfitabilityPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Max Profit/ha:</span> R{{ profitabilitySummary.maxProfitPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Max Loss/ha:</span> R{{ profitabilitySummary.maxLossPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Profitable Area:</span> {{ profitabilitySummary.profitableAreaHa?.toFixed(2) }} HA</p>
                        </div>
                    </div>

                    <button mat-icon-button id="legends-button" (click)="toggleLegendTwo = !toggleLegendTwo" [ngStyle]="{'margin-top' : !toggleLegendTwo ? '15px' : ''}">
                        <div style="display: flex; flex-direction: row;" >
                            <div id="history-icon-container" style="margin-right: 5px;">
                                <mat-icon id="legend-icon">{{toggleLegendTwo ? 'expand_more' : 'expand_less'}}</mat-icon>
                            </div>
                            <div id="history-label-container">
                                <label id="legends-label">Legends</label>
                            </div>
                        </div>
                    </button>
                </div>

                <div class="close-container">
                    <button *ngIf="mapsClose" mat-icon-button (click)="showCompareAnalysis()">
                        <mat-icon style="color: white;">highlight_off</mat-icon>
                    </button>
                </div>

<div class="info-container-pin-overlay">

    <!-- <div  class="container-glass glassMorphism-effect" *ngIf="isPinMarkersVisible" style="pointer-events: auto !important;">
    <div class="box">
    <div class="close-glass" (click)="clearPins()">X</div>
        <div class="inner-glass-box-container">
        <strong> Pin Type: {{selectedPinType.name}}</strong>
        <p class="text-no-margin">Range:</p>
        <span style="min-width: 135px !important;">{{savedPinStartDate}} - {{savedPinEndDate}}</span>
        </div>
    </div>
    </div> -->

    <div class="container-glass glassMorphism-effect" *ngIf="titleMapTwo" style="pointer-events: auto !important;">
    <div class="box">
    <div class="close-glass" (click)="removeAnalysisTwo()"><img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon-light"></div>
        <div class="inner-glass-box-container">
        <p class="text-no-margin">{{historyTitleMapTwo}}</p>
        <p class="text-no-margin" *ngIf="historySubTitleMapTwo">{{historySubTitleMapTwo}}</p>
        <p class="text-no-margin">Date:  <span style="min-width: 135px !important;"> {{historyDateMapTwo}}</span></p>
        </div>
    </div>
    </div>

</div>
                <div *ngIf="openGridManager" class="grid-manager-top-center">
                    <div *ngIf="!toggleGridManager">
                        <div *ngIf="isGeneratingGrid" class="scrollableLegend glassMorphism-effect grid-loading">
                            <mat-spinner diameter="40"></mat-spinner>
                            <span>Generating Grid...</span>
                        </div>
                        <div *ngIf="!isGeneratingGrid" class="white-grid-dialog grid-dialog-body">



                            <div class="grid-dialog-row">
                                <span class="grid-dialog-title">Field Grid Manager</span>
                                <mat-icon class="grid-dialog-close" (click)="confirmCloseGrid()">close</mat-icon>

                            </div>
                            @if (isGriddingControlVisable) {
                                <div class="grid-dialog-row" style="gap: 8px;">
                                    <div class="grid-stat-card">

                                        <div>Selected Points</div>
                                        <div class="grid-stat-value">{{selectedGridPoints.length}}</div>
                                    </div>
                                    <div class="grid-stat-card">
                                        <div>Rotation</div>
                                        <div class="grid-stat-value">{{(currentRotation ?? 0) + '°'}}</div>
                                    </div>
                                </div>
                                <div class="grid-dialog-row grid-icon-actions">
                                    <button matIconButton [disabled]="markers.length <= 0" (click)="rotateLeft()" matTooltip="Rotate Left 10°">
                                        <mat-icon>rotate_left</mat-icon>
                                    </button>

                                    <input
                                            type="number"
                                            [(ngModel)]="currentRotation"
                                            (change)="regenerateGridWithCurrentSettings()"
                                            [disabled]="markers.length <= 0"
                                            style="width: 40px; text-align: center; border: 1px solid #ccc; border-radius: 4px; padding: 2px 2px; font-size: 12px;"
                                            matTooltip="Rotation (degrees)"
                                    />

                                    <button matIconButton [disabled]="markers.length <= 0" (click)="rotateRight()" matTooltip="Rotate Right 10°">
                                        <mat-icon>rotate_right</mat-icon>
                                    </button>

                                    <button matIconButton [disabled]="markers.length <= 0" (click)="toggleGridLines()" [matTooltip]="showGridLines ? 'Hide Grid Lines' : 'Show Grid Lines'">
                                        <mat-icon>{{ showGridLines ? 'grid_off' : 'grid_on' }}</mat-icon>
                                    </button>


                                    <button matIconButton [disabled]="markers.length <= 0" (click)="addNewGridPoint = !addNewGridPoint" [ngClass]="{'grid-manager-icon-active': addNewGridPoint}" matTooltip="Add New Grid Point">
                                        <mat-icon>ads_click</mat-icon>

                                    </button>
                                    <button matIconButton [disabled]="selectedGridPoints.length <= 0" [ngClass]="{'grid-manager-icon-active': selectedGridPoints.length > 0}" (click)="openGridManagerDialog(true)">
                                        <mat-icon>edit</mat-icon>

                                    </button>
                                         <button matIconButton [disabled]="selectedGridPoints.length <= 0" [ngClass]="{'grid-manager-icon-active': selectedGridPoints.length > 0}" (click)="removeGridPoints(true)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            }
                            <button *ngIf="!griddingGroupName" mat-flat-button style="width: 100%;color: white;" (click)="openGridManagerDialog(false)">Generate New Grid</button>

                                <div *ngIf="griddingGroupName" class="grid-group-name">{{griddingGroupName}}</div>

                            <div class="grid-dialog-row grid-bottom-actions">
                                <ng-container *ngIf="!griddingGroupName">
                                    <button mat-button [disabled]="markers.length <= 0" class="grid-manager-save-button" (click)="openSaveGridDialog()">Save As</button>
                                    <span class="grid-divider">|</span>
                                </ng-container>
                                <button mat-stroked-button class="grid-manager-clear-button" (click)="showGriddingHistory()">History</button>
                                <span class="grid-divider">|</span>
                                <button mat-stroked-button class="grid-manager-clear-button" (click)="clearSamplingGrid()">Clear</button>
                            </div>
                            @if (isGriddingControlVisable) {
                                <div *ngIf="markers.length > 0 && selectedGridPoints.length > 0" style="display: flex; justify-content: center;">
                                    <button matIconButton (click)="removeGridPoints(false)" matTooltip="Deselect Points">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                    <button mat-icon-button id="legends-button" style="position: relative; overflow: visible;" (click)="toggleGridManager = !toggleGridManager">
                        <mat-icon id="legend-icon" style="position: absolute; left: 8px; top: 50%; transform: translateY(-50%);">{{ toggleGridManager ? 'expand_more' : 'expand_less' }}</mat-icon>
                        <label id="legends-label" style="width: 100%; text-align: center; cursor: pointer;">Grid Manager</label>
                    </button>
                </div>

                <div *ngIf="mapsClose"  id="toggle-main-container-field">

                    <div>
                        <button mat-icon-button (click)="openMaps(2)" id="map-toggle-container-1" *ngIf="isAnalysisEmpty">
                            <div id="button-content-1">
                                <div id="history-icon-container-1">
                                    <mat-icon id="expand-rankings-1">expand_less</mat-icon>
                                </div>
                                <div id="history-label-container-1">
                                    <label id="expand-rankings-label-1">{{ 'MAPPING.MAPS-DATA' | translate }}</label>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="oneAction && editing" class="map-label-container">
            <div class="action-container">
                <label class="filter-analysis">{{ action }}</label>
            </div>
        </div>
        <div *ngIf="drawingManager != null && drawingManager.getMap() != null"
            class="map-label-container1">
            <div class="action-container">
                <label class="filter-analysis">{{ action }}</label>
            </div>
        </div>
        <div #div2 [style.flex]="flex2" class="div2">
            <div class="container">
                <router-outlet></router-outlet>
                <google-map (mapDblclick)="placeMarker($event)" #map [zoom]="zoom" [options]="options" width="100%"
                            height="100%">
                    <map-ground-overlay *ngFor="let object of fieldImagesMapOne" [url]="object.image" [bounds]="object.bounds"
                        [opacity]="opacity">
                    </map-ground-overlay>
                    <map-polygon *ngFor="let object of polygon" [paths]="object" [options]="polygonOptions"
                                 (polygonClick)="isDrawingMode && oneAction && drawingType === 'polygon' ? addDrawingPoint($event.latLng.toJSON()) : null"
                                 (polygonMousemove)="isDrawingMode && oneAction && drawingType === 'polygon' && drawnPoints.length > 0 && updatePreviewLine($event.latLng.toJSON())"
                                 (polygonDblclick)="isDrawingMode && oneAction && drawingType === 'circle' ? startCircleDrawing($event.latLng.toJSON()) : (!isDrawingMode ? placeMarker($event) : null)">
                    </map-polygon>
                    @for (marker of markers; track $index) {
                        <map-advanced-marker class="marker"
                            [position]="marker.position" [content]="marker?.content" [title]="marker.title" (mapClick)="openInfo(marker)" (mapDragend)="onMarkerDragEnd(marker, $event)" [gmpDraggable]="marker?.gmpDraggable">
                        </map-advanced-marker>
                    }

                    <div *ngIf="isDrawingMode && oneAction" class="drawing-toolbar">
                        <div class="drawing-toolbar-buttons">
                        <button mat-flat-button
                                [style.background]="drawingType !== 'polygon' ? 'transparent' : ''"
                                [style.color]="'white'"

                                [style.borderRight]="'1px solid rgba(255,255,255,0.2)'"
                                [style.borderRadius]="'0'" (click)="switchDrawingType('polygon', map)"
                                type="button">
                            <mat-icon>pentagon</mat-icon>
                            Polygon
                        </button>
                        <button mat-flat-button
                                [style.color]="'white'"
                                [style.background]="drawingType !== 'circle' ? 'transparent' : ''"

                                [style.borderRight]="'1px solid rgba(255,255,255,0.2)'"
                                [style.borderRadius]="'0'" (click)="switchDrawingType('circle', map)"
                                type="button">
                            <mat-icon>circle</mat-icon>
                            Circle
                        </button>
                        <button mat-flat-button
                                [style.color]="'white'"

                                [style.background]="drawingType !== null ? 'transparent' : ''"
                                [style.borderRadius]="'0'" (click)="switchDrawingType(null, map)"
                                type="button">
                            <mat-icon>pan_tool</mat-icon>
                            Move
                        </button>
                    </div>
                        <div class="drawing-toolbar-help">
                         <span style="color: white; align-self: center; font-size: 13px;">
                            <ng-container *ngIf="drawingType === 'polygon'">
                                Click to drop points
                            </ng-container>
                            <ng-container *ngIf="drawingType === 'circle'">
                                <ng-container *ngIf="!circleCenter">Double Click to place center</ng-container>
                                <ng-container *ngIf="circleCenter">Drag handles to resize</ng-container>
                            </ng-container>
                            <ng-container *ngIf="drawingType === null">
                                Drag to pan
                            </ng-container>
                        </span>
                        </div>
                    </div>
                </google-map>

                <div *ngIf="isDrawingMode && oneAction" class="toggle-main-button drawing-controls">
                    <button mat-flat-button
                            *ngIf="drawingType === 'polygon'"
                            (click)="undoLastPoint(map)"
                            class="undo-btn" type="button">Undo</button>
                    <button mat-flat-button
                            (click)="stopAddingField(map)"
                            type="button">Cancel</button>
                    <button mat-flat-button
                            [disabled]="drawingType === 'polygon' ? drawnPoints.length < 3 : !circleCenter"
                            (click)="drawingType === 'circle' ? finishCircleDrawing(map) : finishCustomDrawing(map)"
                            type="button">Finish</button>
                </div>

                <div *ngIf="saveEditedArea" class="toggle-main-button">
                    <button class="cancel-edit" mat-flat-button (click)="cancelEditArea(map)" type="button">
                        Cancel
                    </button>
                    <button class="update-fields" mat-flat-button (click)="updateArea()" type="button">
                        {{ 'MAPPING.EXCLUDE-AREA' | translate }}
                    </button>
                </div>

                <div *ngIf="!mapsClose && fieldLegendsMapOne?.length < 10 && fieldLegendsMapOne?.length > 0"  class="legend-container"  style="display: flex; flex-direction: column; align-items: end">
                            
                     <!-- NOT THIS ONE -->
                    <div *ngIf="!toggleLegend">
                        <div style="padding: 10px 0" class="inner-glass-box-container  glassMorphism-effect">
                            <div class="inner-legend-container" *ngFor="let fieldLegend of fieldLegendsMapOne">
                                <div class="legend-color" [style.background-color]="fieldLegend.color"></div>
                                <label class="legend-value">{{ fieldLegend.value }} ({{ fieldLegend.area | number : '1.2-2'}} HA)</label>
                            </div>
                        </div>

                        <div class=" glassMorphism-effect stats-container" *ngIf="isMapTypeSoilMapOne && historyTitleMapOne !== 'PROFITABILITY'">
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-min-container">Min:</span> {{ legendStatsMapOne.min ? legendStatsMapOne.min : placeholder}} </p>
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-max-container">Max:</span> {{ legendStatsMapOne.max ? legendStatsMapOne.max : placeholder}}</p>
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-avg-container">Avg:</span> {{ legendStatsMapOne.avg ? legendStatsMapOne.avg : placeholder }}</p>
                        </div>

                        <div class="glassMorphism-effect profitability-stats-container" *ngIf="historyTitleMapOne === 'PROFITABILITY' && profitabilitySummary">
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Total Profit:</span> R{{ profitabilitySummary.totalProfitability?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Avg Profit/ha:</span> R{{ profitabilitySummary.avgProfitabilityPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Max Profit/ha:</span> R{{ profitabilitySummary.maxProfitPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Max Loss/ha:</span> R{{ profitabilitySummary.maxLossPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Profitable Area:</span> {{ profitabilitySummary.profitableAreaHa?.toFixed(2) }} HA</p>
                        </div>
                    </div>

                    <button *ngIf="fieldLegendsMapOne.length != 0" mat-icon-button id="legends-button" (click)="toggleLegend = !toggleLegend" [ngStyle]="{'margin-top' : !toggleLegend ? '15px' : ''}">
                        <div style="display: flex; flex-direction: row;" >
                            <div id="history-icon-container" style="margin-right: 5px;">
                                <mat-icon id="legend-icon">{{toggleLegend ? 'expand_more' : 'expand_less'}}</mat-icon>
                            </div>
                            <div id="history-label-container">
                                <label id="legends-label">Legends</label>
                            </div>
                        </div>
                    </button>
                </div>

                <div *ngIf="!mapsClose && fieldLegendsMapOne.length >= 10" class="legend-container" style="display: flex; flex-direction: column; align-items: end">
                    <div *ngIf="!toggleLegend" class="scrollableLegend-container ">

                        <div style="padding: 10px 0" class="scrollableLegend glassMorphism-effect">
                            <div class="inner-legend-container1" *ngFor="let fieldLegend of fieldLegendsMapOne">
                                <div class="legend-color" [style.background-color]="fieldLegend.color"></div>
                                <label class="legend-value">{{ fieldLegend.value }} ({{ fieldLegend.area | number : '1.2-2'}} HA)</label>
                            </div>
                        </div>

                        <div class=" glassMorphism-effect stats-container" *ngIf="isMapTypeSoilMapOne && historyTitleMapOne !== 'PROFITABILITY'">
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-min-container">Min:</span> {{ legendStatsMapOne.min ? legendStatsMapOne.min : placeholder}} </p>
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-max-container">Max:</span> {{ legendStatsMapOne.max ? legendStatsMapOne.max : placeholder}}</p>
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-avg-container">Avg:</span> {{ legendStatsMapOne.avg ? legendStatsMapOne.avg : placeholder }}</p>
                        </div>

                        <div class="glassMorphism-effect profitability-stats-container" *ngIf="historyTitleMapOne === 'PROFITABILITY' && profitabilitySummary">
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Total Profit:</span> R{{ profitabilitySummary.totalProfitability?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Avg Profit/ha:</span> R{{ profitabilitySummary.avgProfitabilityPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Max Profit/ha:</span> R{{ profitabilitySummary.maxProfitPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Max Loss/ha:</span> R{{ profitabilitySummary.maxLossPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Profitable Area:</span> {{ profitabilitySummary.profitableAreaHa?.toFixed(2) }} HA</p>
                        </div>
                    </div>

                    <button mat-icon-button id="legends-button" (click)="toggleLegend = !toggleLegend" [ngStyle]="{'margin-top' : !toggleLegend ? '15px' : ''}">
                        <div style="display: flex; flex-direction: row;" >
                            <div id="history-icon-container" style="margin-right: 5px;">
                                <mat-icon id="legend-icon">{{toggleLegend ? 'expand_more' : 'expand_less'}}</mat-icon>
                            </div>
                            <div id="history-label-container">
                                <label id="legends-label">Legends</label>
                            </div>
                        </div>
                    </button>
                </div>

                <!-- NOT THIS ONE EITHER - map 1 right split view -->
                <div *ngIf="mapsClose && fieldLegendsMapOne.length != 0" class="legend-container" style="display: flex; flex-direction: column; align-items: end">
                    <div *ngIf="!toggleLegend" class="scrollableLegend-container">
                        <div style="padding: 10px 0" class="scrollableLegend glassMorphism-effect">
                            <div class="inner-legend-container" *ngFor="let fieldLegend of fieldLegendsMapOne">
                                <div class="legend-color" [style.background-color]="fieldLegend.color"></div>
                                <label class="legend-value">{{ fieldLegend.value }} ({{ fieldLegend.area }} HA)</label>
                            </div>
                        </div>

                        <div class=" glassMorphism-effect stats-container" *ngIf="isMapTypeSoilMapOne && historyTitleMapOne !== 'PROFITABILITY'">
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-min-container">Min:</span> {{ legendStatsMapOne.min ? legendStatsMapOne.min : placeholder}} </p>
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-max-container">Max:</span> {{ legendStatsMapOne.max ? legendStatsMapOne.max : placeholder}}</p>
                            <p class="text-min-max-avg"> <span class="text-min-max-avg-container text-avg-container">Avg:</span> {{ legendStatsMapOne.avg ? legendStatsMapOne.avg : placeholder }}</p>
                        </div>

                        <div class="glassMorphism-effect profitability-stats-container" *ngIf="historyTitleMapOne === 'PROFITABILITY' && profitabilitySummary">
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Total Profit:</span> R{{ profitabilitySummary.totalProfitability?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Avg Profit/ha:</span> R{{ profitabilitySummary.avgProfitabilityPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Max Profit/ha:</span> R{{ profitabilitySummary.maxProfitPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Max Loss/ha:</span> R{{ profitabilitySummary.maxLossPerHa?.toFixed(0) }}</p>
                            <p class="text-min-max-avg"><span class="text-min-max-avg-container">Profitable Area:</span> {{ profitabilitySummary.profitableAreaHa?.toFixed(2) }} HA</p>
                        </div>
                    </div>

                    <button mat-icon-button id="legends-button" (click)="toggleLegend = !toggleLegend" [ngStyle]="{'margin-top' : !toggleLegend ? '15px' : ''}">
                        <div style="display: flex; flex-direction: row;" >
                            <div id="history-icon-container" style="margin-right: 5px;">
                                <mat-icon id="legend-icon">{{toggleLegend ? 'expand_more' : 'expand_less'}}</mat-icon>
                            </div>
                            <div id="history-label-container">
                                <label id="legends-label">Legends</label>
                            </div>
                        </div>
                    </button>

                </div>

                <eco-fab-speed-dial
                    class="speed-dial-container">
                    <eco-fab-speed-dial-trigger *ngIf="!isSingleTypeSequenceViewActive && !isCustomSequenceViewActive && !isChemCompareViewActive">
                        <button (click)="openOptions()"  mat-fab label="menu" class="map-menu-circular">
                            <mat-icon class="material-icons">add</mat-icon>
                        </button>
                    </eco-fab-speed-dial-trigger>

                    <eco-fab-speed-dial-actions>
                        <!-- <button mat-mini-fab (click)="showPinAnalysis()" color="white" matTooltip="Pin Analysis"
                            matTooltipPosition="after" aria-label="pinAnalysis">
                            <mat-icon class="material-icons">show_chart</mat-icon>
                        </button> -->
                        <!-- <button mat-mini-fab (click)="clearPins()" color="white"  data-title="Remove Pins"
                            aria-label="removePins">
                            <mat-icon class="material-icons">delete_forever</mat-icon>
                        </button> -->

                        <button *ngIf="isSequenceViewRoleActive" mat-mini-fab  (click)="openCustonSequenceView();" data-title="Custom-Sequence-View"
                            aria-label="custom-sequence-view">
                            <mat-icon class="material-icons">dashboardcustomize</mat-icon>
                             <!-- <a routerLink="/field/sequence">Sequence</a> -->
                        </button>

                        <button *ngIf="isSequenceViewRoleActive" mat-mini-fab  (click)="openSingleTypeSequenceView()" data-title="Sequence-View"
                            aria-label="sequence-view">
                            <mat-icon class="material-icons">dataset</mat-icon>
                             <!-- <a routerLink="/field/sequence">Sequence</a> -->
                        </button>

                        <button mat-mini-fab *ngIf="!editing && selectedMapsItem?.analysisId && isVrtCreatorRole" (click)="createVrtFromOverlay(map)" data-title="Create VRT from this map"
                            aria-label="createVrt">
                            <mat-icon class="material-icons">grain</mat-icon>
                        </button>
                        <button mat-mini-fab *ngIf="!editing" (click)="editField(map)" data-title="Edit Field"
                            aria-label="edit">
                            <mat-icon class="material-icons">edit</mat-icon>
                        </button>
                        <button mat-mini-fab *ngIf="editing" data-title="Close Edit"
                             aria-label="closeEdit" (click)="stopEditing()">
                            <mat-icon class="material-icons">cancel</mat-icon>
                        </button>
<!--                        <button mat-mini-fab *ngIf="!splitField && !editing" data-title="Split Field"-->
<!--                                (click)="openSplitFieldDialog(map)">-->
<!--                            <img class="icon split-field-icon" src="./assets/icons/split_scene_left.png" alt="Split Field" />-->
<!--                        </button>-->
                        <button mat-mini-fab (click)="removeAreas()" color="white"  data-title="Remove Excluded Area(s)"
                            aria-label="removeArea">
                            <mat-icon class="material-icons">delete</mat-icon>
                        </button>
                        <button mat-mini-fab color="white"  data-title="Exclude Area"
                            (click)="excludeArea(map)">
                            <img class="icon" src="./assets/icons/exclude_area.png" alt="Exclude Area" />
                        </button>
                        <button mat-mini-fab *ngIf="loadingPins" (click)="loadSavedPins()" color="white" data-title="Loading Pins"
                             aria-label="loadingSavedPins">
                            <mat-progress-spinner class="progressSpinner" [diameter]="36" [color]="myCustomColor" style="padding-top: 2px;"
                                [value]="myCustomValue" [mode]="mode">
                            </mat-progress-spinner>
                            <mat-icon class="img spinner-pin-icon">location_on</mat-icon>
                        </button>
                        <button mat-mini-fab *ngIf="!loadingPins" (click)="newShowSavedPins()" color="white" data-title="View Saved Pins"
                           aria-label="SavedPins">
                            <mat-icon class="material-icons">location_on</mat-icon>
                        </button>
                        <button mat-mini-fab (click)="showCompareAnalysis()" color="white"  data-title="Compare Analysis"
                            aria-label="compareAnalysis">
                            <mat-icon class="material-icons">layers</mat-icon>
                        </button>
                        <button mat-mini-fab *ngIf="viewChemicalCompare" (click)="openChemCompareView()" color="white" data-title="Chemical Compare"
                            aria-label="chemicalCompare">
                            <mat-icon class="material-icons">compare</mat-icon>
                        </button>
                        <!-- <button mat-mini-fab (click)="showSatelliteHistory()" color="white" data-title="Satellite History View"
                            aria-label="satelliteHistoryView">
                            <mat-icon class="material-icons">restore</mat-icon>
                        </button> -->
                        <button mat-mini-fab color="white" data-title="Capture Rainfall"
                            aria-label="captureRainfall" (click)="captureRainfall()">
                            <mat-icon class="material-icons">grain</mat-icon>
                        </button>

                        <button mat-mini-fab color="white"  data-title="Hide/Show Pin Labels"
                        aria-label="showPinLabels" (click)="togglePinLabels()">
                        <!-- <mat-icon class="material-icons">label_off</mat-icon> -->
                        <img class="icon" src="./assets/icons/flag_label.svg" alt="Add Field"/>
                    </button>
                        <button mat-mini-fab (click)="openGridManager = true" *ngIf="!openGridManager && isGriddingViewRoleActive" color="white"
                                data-title="Generate Sampling Grid" aria-label="samplingGrid">
                            <mat-icon class="material-icons">grid_4x4</mat-icon>
                        </button>
                        <button mat-mini-fab *ngIf="openGridManager && isGriddingViewRoleActive" (click)="clearSamplingGrid()"
                                color="white" data-title="Clear Sampling Grid" aria-label="clearGrid">
                            <mat-icon class="material-icons">clear_all</mat-icon>
                        </button>
                    </eco-fab-speed-dial-actions>
                </eco-fab-speed-dial>

                <!-- Weather Forecast Button and Card -->
                <div *ngIf="isWeatherForecastEnabled && !isSingleTypeSequenceViewActive && !isCustomSequenceViewActive && !isChemCompareViewActive" class="weather-forecast-wrapper">
                    <button mat-mini-fab class="weather-forecast-btn" (click)="toggleWeatherForecast()" 
                            *ngIf="!showWeatherCard" aria-label="Weather Forecast">
                        <mat-icon class="material-icons">cloud</mat-icon>
                    </button>
                    <div *ngIf="showWeatherCard" class="weather-forecast-card">
                        <app-weather-forecast 
                            [forecasts]="weatherForecasts" 
                            [isLoading]="isWeatherLoading"
                            (dismiss)="toggleWeatherForecast()">
                        </app-weather-forecast>
                    </div>
                </div>

                <div *ngIf="saveField" class="toggle-main-button flex-row end">
                    <button class="update-field" mat-flat-button (click)="updateField()"
                        type="button">{{ 'MAPPING.SAVE-CHANGES' | translate }}</button>
                </div>

                <div *ngIf="saveArea" class="toggle-main-button  flex-row end">
                    <button class="update-fields-field" mat-flat-button (click)="updateArea()"
                        type="button">{{ 'MAPPING.EXCLUDE-AREA' | translate }}</button>
                </div>

                <div *ngIf="saveEditedField" class="toggle-main-button  flex-row end">
                    <button class="update-fields" mat-flat-button (click)="updateEditedField(map)" type="button">{{ 'MAPPING.ADD-FIELD' | translate }}</button>
                </div>

<div class="info-container-pin-overlay">

    <div class="container-glass glassMorphism-effect" *ngIf="isPinMarkersVisible" style="pointer-events: auto !important;">
    <div class="box">
    <div class="close-glass" (click)="clearPins()"> <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon-light"></div>
        <div class="inner-glass-box-container">
        <p class="text-no-margin"> Pin Type: {{selectedPinType.name}}</p>
        <p class="text-no-margin" *ngIf="savedPinStartDate || savedPinEndDate">Range:  <span style="min-width: 135px !important;">{{savedPinStartDate}} - {{savedPinEndDate}}</span></p>
       
        </div>
    </div>
    </div>

    <div class="container-glass glassMorphism-effect" *ngIf="titleMapOne" style="pointer-events: auto !important;">
        <div class="box">
            <div class="close-glass" (click)="removeAnalysisOne()"><img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon-light"></div>
                <div class="inner-glass-box-container">
                    <p class="text-no-margin">{{historyTitleMapOne}}</p>
                    <p class="text-no-margin" *ngIf="historySubTitleMapOne">{{historySubTitleMapOne}}</p>
                    <p class="text-no-margin">Date:  <span style="min-width: 135px !important;"> {{historyDateMapOne}}</span></p>
                 </div>
            </div>
        </div>
 </div>
                <div  id="toggle-main-container" *ngIf="!isSingleTypeSequenceViewActive && !isCustomSequenceViewActive && !isChemCompareViewActive">

                    <div>
                        <button mat-icon-button (click)="openMaps(1)" id="map-toggle-container" *ngIf="isAnalysisEmpty">
                            <div id="button-content">
                                <div id="history-icon-container">
                                    <mat-icon id="expand-rankings">expand_less</mat-icon>
                                </div>
                                <div id="history-label-container">
                                    <label id="expand-rankings-label">{{ 'MAPPING.MAPS-DATA' | translate }}</label>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div #div6 [ngStyle]="{'min-width': flex3 + '%'}" class="div6">
        <div class="satellite-heading">
            <label>{{ 'FIELD.SATELLITE-HISTORY' | translate }}</label>
            <button mat-icon-button class="close-pins" (click)="showSatelliteHistory()">
                <mat-icon style="color: white;">highlight_off</mat-icon>
            </button>
        </div>
        <div class="scrollableSatellite">
            <div *ngFor="let satelliteHistory of satelliteHistories">
                <div class="sat-history-line"></div>
                <div class="row-container" *ngIf="satelliteHistory.coverageType == 'NO_SERVER_DATA'">
                    <img class="coverage-img" src="../../assets/icons/no_data.svg" alt="No Server Data"/>
                    <div class="text-info-container">
                        <label class="date-label">{{ satelliteHistory.imageDate | date:'yyyy-MM-dd'}}</label>
                        <label class="description-label">{{ 'FIELD.NO-SERVER-DATA' | translate }}</label>
                    </div>
                </div>
                <div class="row-container" *ngIf="satelliteHistory.coverageType == 'NO_DATA'">
                    <img class="coverage-img" src="../../assets/icons/no_data.svg" alt="No Data"/>
                    <div class="text-info-container">
                        <label class="date-label">{{ satelliteHistory.imageDate | date:'yyyy-MM-dd'}}</label>
                        <label class="description-label">{{ 'FIELD.NO-DATA' | translate }}</label>
                    </div>
                </div>
                <div class="row-container" *ngIf="satelliteHistory.coverageType == 'CLOUD'">
                    <img class="coverage-img" src="../../assets/icons/cloudy.png" alt="Cloudy"/>
                    <div class="text-info-container">
                        <label class="date-label">{{ satelliteHistory.imageDate | date:'yyyy-MM-dd'}}</label>
                        <label class="description-label">{{ 'FIELD.CLOUD-COVER' | translate }}</label>
                    </div>
                </div>
                <div class="row-container" *ngIf="satelliteHistory.coverageType == 'PARTIAL'"
                    (click)="overlaySatelliteHistory(satelliteHistory)">
                    <img class="coverage-img" src="../../assets/icons/mostly_cloudy.png" alt="Mostly Cloudy"/>
                    <div class="text-info-container">
                        <label class="date-label">{{ satelliteHistory.imageDate | date:'yyyy-MM-dd'}}</label>
                        <label class="description-label">{{ 'FIELD.PARTIAL-CLOUD' | translate }}</label>
                    </div>
                </div>
                <div class="row-container" *ngIf="satelliteHistory.coverageType == 'CLEAR'"
                    (click)="overlaySatelliteHistory(satelliteHistory)">
                    <img class="coverage-img" src="../../assets/icons/sunny.png" alt="Sunny"/>
                    <div class="text-info-container">
                        <label class="date-label">{{ satelliteHistory.imageDate | date:'yyyy-MM-dd'}}</label>
                        <label class="description-label">{{ 'FIELD.LOADED' | translate }}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
